/**
 * Bootstrap 4 jQuery modal helpers (TBF-816 T2/T3): scroll What's Included to the
 * clicked kit item, move focus to the close control, and trap Tab inside the dialog
 * until close (Escape / dismiss still handled by Bootstrap + global.js).
 */
(function () {
  function findVerticalScrollParent(el, boundary) {
    var p = el && el.parentElement;
    while (p && p !== boundary) {
      try {
        var st = window.getComputedStyle(p);
        var y = st.overflowY;
        var o = st.overflow;
        var scrollable =
          y === 'auto' ||
          y === 'scroll' ||
          o === 'auto' ||
          o === 'scroll';
        if (scrollable && p.scrollHeight > p.clientHeight + 2) {
          return p;
        }
      } catch (e) {}
      p = p.parentElement;
    }
    return null;
  }

  function scrollModalRowToTop(modalEl, row, insetPx) {
    if (!row || !modalEl.contains(row)) {
      return;
    }
    var inset = typeof insetPx === 'number' ? insetPx : 10;
    var scrollHost =
      findVerticalScrollParent(row, modalEl) ||
      modalEl.querySelector('.model-content-description') ||
      modalEl.querySelector('.modal-dialog') ||
      modalEl;
    var rowRect = row.getBoundingClientRect();
    var hostRect = scrollHost.getBoundingClientRect();
    scrollHost.scrollTop += rowRect.top - hostRect.top - inset;
  }

  function clearWiRowSelection(modalEl) {
    if (!modalEl || !modalEl.querySelectorAll) {
      return;
    }
    modalEl.querySelectorAll('.wi-product-row--selected').forEach(function (n) {
      n.classList.remove('wi-product-row--selected');
    });
  }

  function init($) {
    $(document).on('show.bs.modal', '.product-popup', function (e) {
      var rt = e.relatedTarget;
      var id =
        rt && rt.getAttribute && rt.getAttribute('data-wi-scroll-id');
      $(this).data('wiScrollTargetId', id || '');

      var opener =
        rt && rt.nodeType === 1
          ? rt
          : document.activeElement && document.activeElement.nodeType === 1
            ? document.activeElement
            : null;
      if (opener && this.contains(opener)) {
        opener = null;
      }
      if (
        opener &&
        (opener === document.body || opener === document.documentElement)
      ) {
        opener = null;
      }
      $(this).data('tbfModalOpener', opener);
    });

    $(document).on('shown.bs.modal', '.product-popup', function () {
      var modalEl = this;
      var $modal = $(modalEl);
      var targetId = $modal.data('wiScrollTargetId');
      var scrollRoot =
        modalEl.querySelector('.model-content-description') ||
        modalEl.querySelector('.modal-dialog') ||
        modalEl;

      var live = modalEl.querySelector('[data-wi-live-region]');
      if (live) {
        live.textContent = '';
      }

      clearWiRowSelection(modalEl);

      if (targetId && typeof document.getElementById === 'function') {
        var row = document.getElementById(targetId);
        if (row && modalEl.contains(row)) {
          row.classList.add('wi-product-row--selected');
          var scrollHost =
            findVerticalScrollParent(row, modalEl) ||
            modalEl.querySelector('.model-content-description') ||
            modalEl.querySelector('.modal-dialog') ||
            modalEl;
          if (scrollHost && scrollHost.scrollTop !== undefined) {
            scrollHost.scrollTop = 0;
          }
          requestAnimationFrame(function () {
            if (!modalEl.classList.contains('show')) {
              return;
            }
            scrollModalRowToTop(modalEl, row, 10);
          });
        }
      } else if (scrollRoot && scrollRoot.scrollTop !== undefined) {
        scrollRoot.scrollTop = 0;
      }

      var closeBtn =
        modalEl.querySelector('.close[data-dismiss="modal"]') ||
        modalEl.querySelector('button.close') ||
        modalEl.querySelector('[data-dismiss="modal"]');

      function announceWiRowDelta() {
        if (!modalEl.classList.contains('show') || !live || !targetId) {
          return;
        }
        var rowForAnnounce = document.getElementById(targetId);
        if (!rowForAnnounce || !modalEl.contains(rowForAnnounce)) {
          return;
        }
        var titleEl = rowForAnnounce.querySelector(
          '.popup-product-title, h2.popup-product-title, p.popup-product-title'
        );
        var t =
          titleEl && titleEl.textContent
            ? titleEl.textContent.replace(/\s+/g, ' ').trim()
            : '';
        if (!t) {
          return;
        }
        if (t.length > 140) {
          t = t.slice(0, 137) + '\u2026';
        }
        live.textContent = '';
        requestAnimationFrame(function () {
          if (!modalEl.classList.contains('show')) {
            return;
          }
          live.textContent = t;
        });
      }

      function applyTrap() {
        if (!modalEl.classList.contains('show')) {
          return;
        }
        if (typeof window.trapFocus === 'function' && closeBtn) {
          window.trapFocus(modalEl, closeBtn);
        } else if (closeBtn && typeof closeBtn.focus === 'function') {
          closeBtn.focus({ preventScroll: true });
        }
        setTimeout(announceWiRowDelta, 250);
      }

      setTimeout(applyTrap, 0);
    });

    $(document).on('hidden.bs.modal', '.product-popup', function () {
      var modalEl = this;
      clearWiRowSelection(modalEl);
      var live = modalEl.querySelector('[data-wi-live-region]');
      if (live) {
        live.textContent = '';
      }
      var $modal = $(modalEl);
      var opener = $modal.data('tbfModalOpener');
      $modal.removeData('tbfModalOpener');
      if (typeof window.removeTrapFocus === 'function') {
        if (opener && typeof opener.focus === 'function' && document.contains(opener)) {
          window.removeTrapFocus(opener);
        } else {
          window.removeTrapFocus(null);
        }
      } else if (opener && typeof opener.focus === 'function' && document.contains(opener)) {
        opener.focus({ preventScroll: true });
      }
    });
  }

  function run() {
    if (typeof jQuery === 'undefined') return;
    init(jQuery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
